import React, { useEffect, useState } from "react";
import Loading from "../../shared/Loading";

const CartCard1 = ({ data, discount, handleCartUpdate, handleDeleteCart }) => {
  // getting props
  const [price, setPrice] = useState(data?.productId?.unit_price);
  const [q, setQ] = useState(data?.quantity);

  useEffect(() => {
    if (discount?.category?.includes(data?.productId?.categories[0]))
      setPrice(
        data?.productId?.unit_price -
          (data?.productId?.unit_price * discount?.value) / 100
      );
  }, [data?.productId, discount]);

  if (!data?.productId || !discount) <Loading></Loading>;
  return (
    data?.productId &&
    discount && (
      <div className="flex p-4 px-6 justify-between gap-3 items-center border border-gray-300 text-xs">
        {/* details & quantity incre  */}
        <div className="flex">
          <img className="w-16 rounded-lg" src={data?.productId?.img} alt="" />
          <div className="ml-4">
            <p>Name: {data?.productId?.title}</p>
            <p>Unit Price: BDT {price}</p>

            <div className="flex items-center mt-2">
              <p>Quantity: {q}</p>
              <div className=" grid grid-cols-2 ml-4">
                <button
                  onClick={() => (q === 1 ? setQ(1) : setQ(q - 1))}
                  className="btn btn-sm btn-outline rounded-none"
                >
                  -
                </button>
                <button
                  onClick={() => setQ(q + 1)}
                  className="btn btn-sm btn-outline rounded-none"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* price & btn */}
        <div>
          <p className="">Total Price: BDT{price * q}</p>
          <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-1 mt-2">
            <button
              onClick={() => handleCartUpdate(data?.productId?._id, q)}
              className="btn btn-xs text-white bg-warning border-none"
              type=""
            >
              update item
            </button>
            <button
              onClick={() => handleDeleteCart(data?.productId?._id)}
              className="btn btn-xs text-white bg-red-500 border-none"
              type=""
            >
              remove item
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default CartCard1;
